export * from "./icons";
export * from "./palettes";
//# sourceMappingURL=index.js.map